import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from "@angular/common/http";
import { MarkdownModule } from "ngx-markdown";

import { OpenSourceRoutingModule } from './open-source-routing.module';

import { OpenSourceComponent } from './open-source.component';
import { ComponentsModule } from "../shared/components/components.module";



@NgModule({
  declarations: [
    OpenSourceComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    HttpClientModule,
    MarkdownModule.forChild(),
    OpenSourceRoutingModule,
    ComponentsModule,
  ],
})
export class OpenSourceModule { }
